// getters
export const GETTERS_PROGRAM_CATEGORIES_POINT =
  "GETTERS_PROGRAM_CATEGORIES_POINT";
export const GETTERS_PROGRAM_SUB_CATEGORIES = "GETTERS_PROGRAM_SUB_CATEGORIES";

// action
export const ACTION_GET_PROGRAM_CATEGORIES_LIST =
  "ACTION_GET_PROGRAM_CATEGORIES_LIST";
export const ACTION_GET_SUB_PROGRAM_CATEGORIES =
  "ACTION_GET_SUB_PROGRAM_CATEGORIES";
export const ACTION_SET_PROGRAM_CATEGORIES_LIST =
  "ACTION_SET_PROGRAM_CATEGORIES_LIST";
export const ACTION_ADD_PROGRAM_CATEGORY_POINTS =
  "ACTION_ADD_PROGRAM_CATEGORY_POINTS";
export const ACTION_EDIT_PROGRAM_CATEGORY_POINTS =
  "ACTION_EDIT_PROGRAM_CATEGORY_POINTS";
export const ACTION_EDIT_PROGRAM_LIST_CATEGORY_POINTS =
  "ACTION_EDIT_PROGRAM_LIST_CATEGORY_POINTS";
export const ACTION_DELETE_PROGRAM_CATEGORY_POINTS =
  "ACTION_DELETE_PROGRAM_CATEGORY_POINTS";
export const ACTION_ADD_PROGRAM_SUB_CATEGORY_POINTS =
  "ACTION_ADD_PROGRAM_SUB_CATEGORY_POINTS";
export const ACTION_EDIT_PROGRAM_SUB_CATEGORY_POINTS =
  "ACTION_EDIT_PROGRAM_SUB_CATEGORY_POINTS";
export const ACTION_DELETE_PROGRAM_SUB_CATEGORY_POINTS =
  "ACTION_DELETE_PROGRAM_SUB_CATEGORY_POINTS";
export const ACTION_EDIT_LIST_PROGRAM_CATEGORY_POINTS =
  "ACTION_EDIT_LIST_PROGRAM_CATEGORY_POINTS";
export const ACTION_EDIT_LIST_PROGRAM_SUBCATEGORY_POINTS =
  "ACTION_EDIT_LIST_PROGRAM_SUBCATEGORY_POINTS";
// mutation
export const MUTATION_SET_PROGRAM_CATEGORIES_POINT =
  "MUTATION_SET_PROGRAM_CATEGORIES_POINT";
export const MUTATION_SET_SUB_PROGRAM_CATEGORIES =
  "MUTATION_SET_SUB_PROGRAM_CATEGORIES";



// WEBPACK FOOTER //
// ./src/store/modules/basic_program_points/constants.js